import React, { FC } from 'react'
import { ConnectedProps, connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { EnergyDistribution, NutritionAnalysisLayout, PanelTextPicker, WrappedInfoPlaceholder } from '../components'
import PLACEHOLDER_TEXT from '../consts/placeholderText'
import useCalculateRange from '../hooks/useCalculateRange'
import useDateRangePanel from '../hooks/useDateRangePanel'

import { DateRangeString, EnergyDistributionType, ReduxStoreState, analyticsEnergyDistributionDateRanges } from 'Models'
import {
  analyticsCacheRevisionSelector,
  energyDistributionSelector,
  fetchEnergyDistributionAction,
  isEnergyDistributionLoadingSelector
} from 'ReduxStore/myAnalytics'
import { analyticsEnergyDistributionDateRangeSelector, updateUserSettingsAction } from 'ReduxStore/userSettings'

type SelectorProps = {
  analyticsEnergyDistributionDateRange?: DateRangeString
  analyticsCacheRevision: number
  energyDistribution?: EnergyDistributionType
  isEnergyDistributionLoading: boolean
}

const mapStateToProps = createStructuredSelector<ReduxStoreState, SelectorProps>({
  analyticsEnergyDistributionDateRange: analyticsEnergyDistributionDateRangeSelector,
  analyticsCacheRevision: analyticsCacheRevisionSelector,
  energyDistribution: energyDistributionSelector,
  isEnergyDistributionLoading: isEnergyDistributionLoadingSelector
})

const mapDispatchToProps = {
  fetchEnergyDistribution: fetchEnergyDistributionAction,
  updateUserSettings: updateUserSettingsAction
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

const EnergyDistributionPage: FC<PropsFromRedux> = ({
  fetchEnergyDistribution,
  updateUserSettings,
  analyticsEnergyDistributionDateRange,
  analyticsCacheRevision,
  energyDistribution,
  isEnergyDistributionLoading
}: PropsFromRedux) => {
  const calculateRange = useCalculateRange()

  const energyDistributionPanel = useDateRangePanel({
    analyticsDateRange: analyticsEnergyDistributionDateRange,
    settingsKey: 'analyticsEnergyDistributionDateRange',
    calculateRange,
    fetchFn: fetchEnergyDistribution,
    refreshKey: analyticsCacheRevision,
    updateUserSettings
  })

  return (
    <NutritionAnalysisLayout>
      <PanelTextPicker
        onChange={energyDistributionPanel.handleChange}
        items={analyticsEnergyDistributionDateRanges}
        selectedKey={analyticsEnergyDistributionDateRange}
        title="Mahlzeitenverteilung"
      >
        {energyDistribution || isEnergyDistributionLoading ? (
          <EnergyDistribution energyDistribution={energyDistribution} loading={isEnergyDistributionLoading} />
        ) : (
          <WrappedInfoPlaceholder text={PLACEHOLDER_TEXT} />
        )}
      </PanelTextPicker>
    </NutritionAnalysisLayout>
  )
}

export default connector(EnergyDistributionPage)
